import { textColors } from "@/app/theme/palette";
import { CONTENTFUL_CUSTOM_COMPONENTS } from "@/lib/utils/studio";
import { textColorOptions } from "@/lib/utils/studio/textColorOptions";
import { ComponentDefinition } from "@contentful/experiences-core";

export { default as MuiIcon } from "./MuiIcon";

export const MuiIconDefinition: ComponentDefinition = {
  id: CONTENTFUL_CUSTOM_COMPONENTS.MUI_ICON.id,
  name: CONTENTFUL_CUSTOM_COMPONENTS.MUI_ICON.name,
  category: "Atoms",
  tooltip: {
    description:
      "Add custom SVG icons to your content. Upload your own SVG code and customize the size to fit your design needs.",
  },
  builtInStyles: ["cfMargin", "cfPadding"],
  variables: {
    iconName: {
      displayName: "MUI Icon Name",
      type: "Text",
      defaultValue: "",
      group: "content",
      validations: {
        bindingSourceType: ["entry", "manual"],
      },
    },
    iconColor: {
      displayName: "MUI Icon Color",
      type: "Text",
      defaultValue: textColors.secondary,
      group: "style",
      description:
        "Any of the palette's text colours, so an icon can match the text it sits beside.",
      validations: {
        in: textColorOptions,
      },
    },
  },
};
